import React, { useRef, useState, useContext } from "react"
import { UserContext } from "../../../context/userContext"
import trcss from "../../../styles/Telerecovery.module.css"
import gMessages from "../../../styles/GlobalMessages.module.css"
import { trApiInvalidMessageReply } from "../telerecoveryApi"
import { InputTextarea } from 'primereact/inputtextarea'
import { Button } from "primereact/button"
import { Toast } from "primereact/toast"
import { Tag } from "primereact/tag"
import { formatPhoneNumber } from "../Utils"

export default function InvalidMessageReply({ selectedConvs, addReply, setSelectedConvs, closeMessageReply }) {
  const [newSMSText, setNewSMSText] = useState("")
  const [sendingMessage, setSendingMessage] = useState(false)
  const userCtx = useContext(UserContext)
  const { user } = userCtx.session
  const toast = useRef(null)

  const sendMessage = () => {
    if (newSMSText === "") {
      return
    }

    var replyMessage = {
      orgAlias: user.organization_alias,
      conversations: selectedConvs.map((c) => c.id),
      body: newSMSText,
      staffId: user.staff_id
    }

    setSendingMessage(true)

    trApiInvalidMessageReply(userCtx.tokenTelerecovery, replyMessage)
      .then(
        (response) => {
          setSendingMessage(false)
          if (response.totalSMSSent === 0) {
            toast.current.show({
              severity: "success",
              detail: "Error sending messages",
              life: 3000,
            })
          } else {
            addReply(response.reply)
            setNewSMSText("")
            closeMessageReply()
          }
        },
        (err) => {
          let mge = "Error sending message"
          if (err.response.status === 400) {
            mge = "The Organization has no telerecovery phone number assigned"
          }
          console.log(err.response.data)
          toast.current.show({
            severity: "error",
            detail: mge,
            life: 3000,
          })
          setSendingMessage(false)
        }
      )
  }

  return (
    <div className={trcss.chatWindow} style={{ height: "100%" }}>
      <Toast ref={toast} />
      <div className={trcss.chatWindowHeader}>
        <p style={{ fontSize: "16px", fontWeight: "600" }}>To</p>
      </div>
      <div style={{ height: "calc(100vh - 95px)", maxHeight: "800px" }}>
        <div className={gMessages.tag_container}>
          {selectedConvs.map((conv, i) => {
            return (
              <Tag key={i} className={gMessages.tag}>
                <div>
                  <span>{formatPhoneNumber(conv.from)}</span>
                  <Button
                    icon="pi pi-times-circle"
                    onClick={() => {
                      //remove conv from selected convs
                      const _selectedConvs = selectedConvs.filter(
                        (c) => c.id !== conv.id
                      )
                      setSelectedConvs(_selectedConvs)
                    }}
                  />
                </div>
              </Tag>
            )
          })}
        </div>
      </div>
      <div className={trcss.chatWindowFooter} style={{ marginTop: "50px" }}>
        <InputTextarea
          placeholder="Type your message"
          autoResize
          className={trcss.newMessageBox}
          value={newSMSText}
          onChange={(e) => setNewSMSText(e.target.value)}
          rows={1}
          disabled={sendingMessage}
        />
        <div style={{ display: "flex", alignItems: "end" }}>
          <Button
            className={trcss.sendBtn}
            onClick={sendMessage}
            loading={sendingMessage}
            disabled={sendingMessage}
          />
        </div>
      </div>
    </div>
  )

}